import { createFormReducer } from '@td/utils';
import { PROVIDER_SURGE_INCENTIVE_CREATE_FORM } from '../action-types';

export default createFormReducer({
  fields:          ['start-date', 'end-date', 'amount', 'states'],
  formActionTypes: PROVIDER_SURGE_INCENTIVE_CREATE_FORM
});
